// extracted by mini-css-extract-plugin
export default {"root":"Overlay_root__Pu7mI","noTracker":"Overlay_noTracker__q8-Bh"};